import React from 'react';
import {Typography, useTheme} from '@mui/material';
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {clearUserData} from "../../utils/userSlice";
import {useDispatch} from "react-redux";
import ExitIcon from "../../assets/images/icon_exit.svg";
import {useMobile} from "../../context/MobileContext";

const LogoutButton: React.FC = () => {
    const {t} = useTranslation()
    const {isMobile} = useMobile()

    const navigate = useNavigate()
    const dispatch = useDispatch();

    const theme = useTheme();
    const isRtl = theme.direction === 'rtl';

    function handleLogout() {
        try {
            localStorage.removeItem('lang')
            clearUserData(dispatch)

            navigate("/login")

            toast.success(t("main.notification.logout.success"));
            return true
        } catch (error) {
            toast.error(t("main.notification.logout.error"));
        }
    }


    return (
        <Typography variant="h6" onClick={handleLogout} sx={{
            textDecoration: 'none',
            color: "rgba(255, 255, 255, 0.66)",
            cursor: 'pointer',
            fontSize: '18px',
            '&:hover': { // Correct hover syntax here
                color: '#007FFF',
                filter: "brightness(0) saturate(100%) invert(29%) sepia(85%) saturate(2673%) hue-rotate(192deg) brightness(102%) contrast(97%)"
            }
        }}>
            {!isMobile && t("main.navbar.logout")}
            <img src={ExitIcon} alt="Exit Icon" style={{
                height: isMobile ? '22px' : '25px',
                position: 'relative',
                top: isMobile ? 4 : 7,
                transform: isRtl ? "scaleX(-1)" : undefined,
                marginRight: isRtl ? isMobile ? 3 : 10 : undefined,
                marginLeft: !isRtl ? isMobile ? 3 : 10 : undefined,
            }}/>
        </Typography>
    );
};

export default LogoutButton;
